import { IComponentOptions, IController } from 'angular';
import './topbar-status-nav.component.scss';


export class TopbarStatusNavController implements IController {
  static $inject = [];
  status;

  constructor() {
  }

  $onInit() {
  }

}

export const TopbarStatusNavComponent: IComponentOptions = {
  controller: TopbarStatusNavController,
  template: require('./topbar-status-nav.component.html'),
  bindings: {
    status: '<'
  }
};



// WEBPACK FOOTER //
// ./app/states/dashboard/components/topbar-status-nav/topbar-status-nav.component.ts